export default "__VITE_ASSET__80mSlqb8__"